import { SsoService } from 'services/SsoService';
import { history } from 'routing/history';

export const ssoService = new SsoService(history);
